import axios from "axios";
const url = process.env.REACT_APP_URL
export const AdminPostPage = async (data) => {
    const xhr = await axios.post(`${url}login/`,data);
      return xhr;
  };